module.exports = __webpack_public_path__ + "img/phone.92be5f35.svg";